import clsx from 'clsx';
import React from 'react';
import WarningIcon from '../../assets/icons/warning-icon.svg?react';
import TextArea from '../TextArea';
import FileInput from '../FileInput';
import Button from '../Button';
import { useButtonSizeSmall } from '../../utils/buttonSizes';

interface MarkAsReviewModalProps {
  otherClasses?: string;
  formHandler: any;
  handleClose: () => void;
}

const MarkAsReviewModal: React.FC<MarkAsReviewModalProps> = ({
  otherClasses,
  formHandler,
  handleClose,
}) => {
  const markAsReviewModalClasses = clsx(otherClasses, 'w-full');

  return (
    <div
      className={markAsReviewModalClasses}
      data-testid="mark-as-review-modal"
    >
      <div className="flex flex-col items-center gap-2.5 text-center">
        <WarningIcon className="[&>g>path]:fill-brand-fair-orange h-85 w-85" />
        <h4 className="text-brand-fair-orange capitalize">Are you sure?</h4>
        <p className="font-inter-variable text-brand-fair-orange -tracking-text-area text-base leading-5 font-normal lg:text-lg">
          Marking for <strong>REVIEW</strong> sends an email to the manager
          confirming completion. The manager may reject the request, and it will
          be reassigned to you.
        </p>
      </div>
      <form
        action="#"
        onSubmit={formHandler?.handleSubmit}
        className="mt-12 flex flex-col"
      >
        <TextArea
          name="description"
          onBlur={formHandler?.handleBlur}
          onChange={formHandler?.handleChange}
          value={formHandler?.values?.description}
          placeholder="Write something here e.g. The assigned corrective action's have been completed successfully..."
          disabled={formHandler?.isSubmitting}
          errorMessage={
            formHandler?.touched.description && formHandler?.errors.description
              ? formHandler?.errors.description
              : ''
          }
          label="Description*"
          otherClasses={{ container: 'w-full mb-6' }}
        />
        <FileInput
          label="Attachments (Optional)"
          name="files"
          selectedFiles={formHandler?.values?.files}
          onChange={(e) => formHandler?.setFieldValue('files', e, true)}
          updateAccept
          accept={{
            'image/png': ['.png'],
            'image/jpeg': ['.jpg', '.jpeg'],
            'video/mp4': ['.mp4'],
            'image/gif': ['.gif'],
            'application/pdf': ['.pdf'],
            'application/msword': ['.doc'],
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
              ['.docx'],
            'video/quicktime': ['.mov'],
            'video/hevc': ['.hevc'],
          }}
          customPlaceholder={{
            label1:
              'Max 3 files allowed, Image size 5mb and video size 50mb allowed.',
            label2: '.png, .jpg/.jpeg, .gif, .mp4, .pdf, .doc, .docx',
            label3: 'Upload Files',
          }}
          onBlur={formHandler?.handleBlur}
          errorMessage={
            formHandler?.errors?.files ? formHandler?.errors?.files : ''
          }
        />
        <div className="mt-12 flex w-full flex-col-reverse gap-x-6 gap-y-15 md:grid md:grid-cols-2">
          <Button
            onClick={handleClose}
            type="button"
            variant="secondary"
            disable={formHandler?.isSubmitting}
            otherClasses="text-brand-fair-orange border-transparent hover:border-brand-fair-orange hover:text-brand-fair-orange"
            size={useButtonSizeSmall()}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            loading={formHandler?.isSubmitting}
            disable={formHandler?.isSubmitting}
            size={useButtonSizeSmall()}
            otherClasses="bg-brand-fair-orange hover:text-brand-fair-orange hover:border-brand-fair-orange "
          >
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
};

export default MarkAsReviewModal;
